import type { MachineNameAndSourceId } from "@common/types/server-list-types";
import { LOOKBACK_AND_POLLING_KEY_PREFIX } from "../constants";
import type { DurationOption } from "../constants";

/** Translated dropdown options for a duration list. */
export const buildDurationOptions = (
  list: readonly DurationOption[],
  translate: (key: string) => string,
): MachineNameAndSourceId[] =>
  list.map((d) => ({
    name: translate(`${LOOKBACK_AND_POLLING_KEY_PREFIX}.${d.labelKey}`),
    source_id: String(d.ms),
  }));
